import { clearToken, retrieveToken } from './storage';

/** Shown while redirecting after 403 / expired session handling. */
export const SESSION_EXPIRED_HOME_MESSAGE =
  'Sessione scaduta. Sarai reindirizzato alla home page fra pochi secondi.';

const DEFAULT_REDIRECT_DELAY_MS = 4000;

/**
 * Clears auth storage, runs optional UI notification, then redirects to brand home.
 *
 * Nuova semantica auth (401 = token scaduto, 403 = errore di business):
 * questa funzione e' chiamata storicamente in due casi molto diversi:
 *  1) guard `retrieveToken() === null` -> sessione realmente assente: logout ok;
 *  2) `error.status === 403` in decine di componenti -> con il nuovo backend
 *     un 403 e' un errore di autorizzazione/regole di business, NON una sessione
 *     scaduta, quindi NON deve fare logout/redirect.
 *
 * Distinguiamo i due casi guardando lo storage: se un token e' ancora presente
 * la chiamata proviene da un 403 di business -> no-op. Il logout per sessione
 * realmente scaduta e' gestito centralmente da `apiFetch` (401 -> refresh ->
 * evento `bsfood:auth-logout`) e dai guard che invocano questa funzione dopo
 * aver verificato l'assenza del token.
 *
 * @param {{ brandPath?: string, onNotify?: () => void, redirectDelayMs?: number }} [options]
 */
export function handleInvalidToken(options = {}) {
  const {
    brandPath = 'bsfood',
    onNotify,
    redirectDelayMs = DEFAULT_REDIRECT_DELAY_MS,
  } = options;

  if (retrieveToken()) {
    return;
  }

  if (onNotify) {
    onNotify();
  }
  clearToken();
  const segment = brandPath || 'bsfood';
  window.setTimeout(() => {
    window.location.href = `/${segment}`;
  }, redirectDelayMs);
}
